import { configConstants } from '../constants';
import axios from 'axios';
import _ from 'lodash';
import { history, setHeaders } from 'helpers';

import objectToFormData from 'object-to-formdata';

export const surveyServices = {
 
    fetchSurveyList,
    addSurvey,
    addSubSurvey,
    getSurveyLists,
    getCompleteSurveyLists,
    getSubSurveyLists,
    getSurveyById,
    getSubSurveyById,
    updateSurvey,
    updateSubSurvey,
    deleteSubSurvey,

};

const formContentType = "multipart/form-data";
const dbDateFormat = "YYYY-MM-DDTHH:mm:ss.sssZ"

function fetchSurveyList() {
    let tmp = axios.get(configConstants.API_BACKEND_CRM + `/survey/surveyByMerchant/`, { headers: setHeaders() })
      .then(response => {
        if (response.data.statusCode.toString() === "200") {
          return { status: true, data: response.data.data, message: response.data.message };
        } else if (response.data.message === "UNAUTHORIZE") {
          history.push('/auth/login')
          return { status: false, data: {}, message: response.data.message, unAlert: true };
        } else {
          return { status: false, data: {}, message: response.data.message };
        }
      }).catch(e => {
        return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
      })
  
    return tmp;
  }

function addSurvey(values) {
    const formData = objectToFormData(
        values
    );

     console.log('formData :',formData);

    let tmp = axios.post(configConstants.API_BACKEND_CRM + '/survey/create-main-topic', formData, { headers: setHeaders({ 'Content-Type': 'multipart/form-data' })
    }).then(response => {
          if (response.data.statusCode.toString() === "200") {
              return {
                  status: true,
                  data: response.data.data,
                  message: response.data.message
              };
          } else if (response.data.message === "UNAUTHORIZE") {
              history.push('/auth/login')
              return { status: false, data: {}, message: response.data.message, unAlert: true };
          } else {
              return {
                  status: false,
                  data: {},
                  message: response.data.message
              };
          }
      });
  return tmp;
}

function addSubSurvey(values) {
    const formData = objectToFormData(
        values
    );

     console.log('formData :',formData);

    let tmp = axios.post(configConstants.API_BACKEND_CRM + '/survey/create-sub-topic', formData, { headers: setHeaders({ 'Content-Type': 'multipart/form-data' })
    }).then(response => {
          if (response.data.statusCode.toString() === "200") {
              return {
                  status: true,
                  data: response.data.data,
                  message: response.data.message
              };
          } else if (response.data.message === "UNAUTHORIZE") {
              history.push('/auth/login')
              return { status: false, data: {}, message: response.data.message, unAlert: true };
          } else {
              return {
                  status: false,
                  data: {},
                  message: response.data.message
              };
          }
      });
  return tmp;
}

function getSurveyLists(reqParams) {
    let tmp = axios.get(configConstants.API_BACKEND_CRM + `/survey?${reqParams}`, { headers: setHeaders() })
      .then(response => {
        if (response.data.statusCode.toString() === "200") {
          return { status: true, data: response.data.data, message: response.data.message };
        } else if (response.data.message === "UNAUTHORIZE") {
          history.push('/auth/login')
          return { status: false, data: {}, message: response.data.message, unAlert: true };
        } else {
          return { status: false, data: {}, message: response.data.message };
        }
      }).catch(e => {
        return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
      })
  
    return tmp;
  }

  function getSubSurveyLists(reqParams) {
    let tmp = axios.get(configConstants.API_BACKEND_CRM + `/survey/subSurvey?${reqParams}`, { headers: setHeaders() })
      .then(response => {
        if (response.data.statusCode.toString() === "200") {
          return { status: true, data: response.data.data, message: response.data.message };
        } else if (response.data.message === "UNAUTHORIZE") {
          history.push('/auth/login')
          return { status: false, data: {}, message: response.data.message, unAlert: true };
        } else {
          return { status: false, data: {}, message: response.data.message };
        }
      }).catch(e => {
        return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
      })
  
    return tmp;
  }

  function getCompleteSurveyLists(reqParams) {
    let tmp = axios.get(configConstants.API_BACKEND_CRM + `/survey/surveyComplete?${reqParams}`, { headers: setHeaders() })
      .then(response => {
        if (response.data.statusCode.toString() === "200") {
          return { status: true, data: response.data.data, message: response.data.message };
        } else if (response.data.message === "UNAUTHORIZE") {
          history.push('/auth/login')
          return { status: false, data: {}, message: response.data.message, unAlert: true };
        } else {
          return { status: false, data: {}, message: response.data.message };
        }
      }).catch(e => {
        return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
      })  

    return tmp;
  }    

function getSurveyById(id) {
    let tmp = axios.get(configConstants.API_BACKEND_CRM + `/survey/${id}`, { headers: setHeaders({ 'Charset': 'utf-8' }) })
        .then(response => {
            if (response.status.toString() === "200") {
                return { status: true, data: response.data.data, message: response.data.message };
            } else if (response.data.message === "UNAUTHORIZE") {
                history.push('/auth/login')
                return { status: false, data: {}, message: response.data.message };
            } else {
                return { status: false, data: {}, message: response.data.message };
            }
        });

    return tmp;
}  

function getSubSurveyById(id) {
    let tmp = axios.get(configConstants.API_BACKEND_CRM + `/survey/subSurvey/${id}`, { headers: setHeaders({ 'Charset': 'utf-8' }) })
        .then(response => {
            if (response.status.toString() === "200") {
                return { status: true, data: response.data.data, message: response.data.message };
            } else if (response.data.message === "UNAUTHORIZE") {
                history.push('/auth/login')
                return { status: false, data: {}, message: response.data.message };
            } else {
                return { status: false, data: {}, message: response.data.message };
            }
        });

    return tmp;
}  

function updateSurvey(values) {
    let surveyId = values._id;
    //values = _.omit(values, "rewardDetail.imgPath")
    const formData = objectToFormData(
        values
    );
  
    let tmp = axios.put(configConstants.API_BACKEND_CRM + `/survey/${surveyId}`, formData, {
        headers: setHeaders({ 'Content-Type': formContentType })
    })
        .then(response => {
            if (response.data.statusCode.toString() === "200") {
                return {
                    status: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else if (response.data.message === "UNAUTHORIZE") {
                history.push('/auth/login')
                return { status: false, data: {}, message: response.data.message, unAlert: true };
            } else {
                return {
                    status: false,
                    data: {},
                    message: response.data.message
                };
            }
        });
    return tmp;
}

function updateSubSurvey(values) {
    let questionId = values._id;
    //values = _.omit(values, "rewardDetail.imgPath")
    const formData = objectToFormData(
        values
    );

    let tmp = axios.put(configConstants.API_BACKEND_CRM + `/survey/subSurvey/${questionId}`, formData, {
        headers: setHeaders({ 'Content-Type': formContentType })
    })
        .then(response => {
            if (response.data.statusCode.toString() === "200") {
                return {
                    status: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else if (response.data.message === "UNAUTHORIZE") {
                history.push('/auth/login')
                return { status: false, data: {}, message: response.data.message, unAlert: true };
            } else {
                return {
                    status: false,
                    data: {},
                    message: response.data.message
                };
            }
        });
    return tmp;
}

function deleteSubSurvey(params) {
    const { _id } = params
    let tmp = axios
      .delete(configConstants.API_BACKEND_CRM + `/survey/subSurvey/${_id}/`,{ headers: setHeaders()})
      .then((response) => {
        if (response.data.statusCode.toString() === "200") {
          return {
            status: true,
            data: response.data.data,
            message: response.data.message,
          }
        } else if (response.data.message === "UNAUTHORIZE") {
          history.push("/auth/login")
          return {
            status: false,
            data: {},
            message: response.data.message,
            unAlert: true,
          }
        } else {
          return { status: false, data: {}, message: response.data.message }
        }
      })
      .catch((e) => {
        return { status: false, data: {}, message: e.message }
      })
    return tmp
  }
